import CryptoJS from 'crypto-js'

export const createHmacString = (ts: string) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_SECRET_KEY!)
  const timestamp = CryptoJS.enc.Utf8.parse(ts)
  const hmac = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(timestamp, key))

  //  const hmac = CryptoJS.HmacSHA256(ts, privateKey).toString(CryptoJS.enc.Hex)
  return hmac;
}

export const detectDevice = (): 'ios' | 'android' | 'desktop' => {
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.search("iphone") > -1 ||
    userAgent.search("ipad") > -1 ||
    userAgent.search("ipod") > -1) {
    return "ios";
  }

  if (userAgent.search("android") > -1) {
    return "android";
  }

  return "desktop";
}

// встроенные браузеры мессенджеров не умеют ни добавлять pkpass в Apple Wallet, ни открывать Google Wallet
export const isInAppBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  const markers = ["gsa/", "fban", "fbav", "instagram", "line/", "micromessenger", "telegram", "whatsapp", "waios/"];
  if (markers.some((marker) => userAgent.includes(marker))) {
    return true;
  }
  // Telegram's iOS browser sends a plain Safari user-agent; only its injected bridge gives it away
  if ((window as unknown as { TelegramWebviewProxy?: unknown }).TelegramWebviewProxy !== undefined) {
    return true;
  }
  switch (detectDevice()) {
    case "ios":
      // Safari, SFSafariViewController, Chrome/Firefox/Edge for iOS all carry the Safari token; bare WKWebView doesn't
      return !userAgent.includes("safari/");
    case "android":
      return userAgent.includes("; wv)");
    default:
      return false;
  }
}

export const openInSystemBrowserUrl = (): string | null => {
  const href = window.location.href
  const target = href.replace(/^https?:\/\//, "")
  switch (detectDevice()) {
    case "ios":
      return `x-safari-https://${target}`
    case "android":
      return `intent://${target}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(href)};end`
    default:
      return null
  }
}

export const copyText = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (e) {
    const area = document.createElement("textarea")
    area.value = text
    area.style.position = "fixed"
    area.style.opacity = "0"
    document.body.appendChild(area)
    area.select()
    const ok = document.execCommand("copy")
    document.body.removeChild(area)
    return ok
  }
}